import type { CarouselSlide } from './CarouselSlidesManager';

const createDefaultSlide = (position: number): CarouselSlide => ({
  position,
});

export const parseCarouselBanners = (
  banners: Array<{
    alt_text?: string;
    breakpoint: 'desktop' | 'mobile';
    id?: number;
    image_url?: string;
    position: number;
    url?: string;
    visible?: boolean;
  }> = []
): { isEnabled: boolean; slides: CarouselSlide[] } => {
  if (!banners.length) {
    return { slides: [createDefaultSlide(1)], isEnabled: true };
  }

  const slidesMap: Record<number, CarouselSlide> = {};
  const isEnabled = banners.some((banner) => banner.visible);

  banners.forEach((banner) => {
    const { position } = banner;

    const slide: CarouselSlide = slidesMap[position] || { position };

    if (banner.breakpoint === 'desktop') {
      slide.desktopImage = banner.image_url;
      slide.desktopId = banner.id;
    } else {
      slide.mobileImage = banner.image_url;
      slide.mobileId = banner.id;
    }

    slide.altText = banner.alt_text;
    slide.link = banner.url;

    slidesMap[position] = slide;
  });

  const slides = Object.values(slidesMap).sort(
    (a, b) => a.position - b.position
  );

  return { slides, isEnabled };
};

export const updateSlide = (
  slides: CarouselSlide[],
  position: number,
  patch: Partial<CarouselSlide>
): CarouselSlide[] =>
  slides.map((slide) =>
    slide.position === position ? { ...slide, ...patch } : slide
  );
